// src/shared/navigation/hotkeys.ts
export interface HotKey {
  /** lower‑case printable key */
  key: string
  path: string
}

export const HOT_KEYS: HotKey[] = [
  { key: 'o', path: '/order' },
  { key: 'c', path: '/cash-register' },
  { key: 's', path: '/sales-purchase' },
  { key: 't', path: '/stock' },
  { key: 'd', path: '/developer' },
  { key: 'a', path: '/admin' },
  { key: 'u', path: '/' },
]
